// extracted by mini-css-extract-plugin
export var activeDot = "_57-c";
export var buttonContainer = "_57-9";
export var channelButton = "_57-a";
export var content = "_57-0";
export var contentFull = "_57-2";
export var contentThird = "_57-1";
export var contentWrapper = "_57-7";
export var description = "_57-5";
export var heightShort = "_57-e";
export var image = "_57-3";
export var imageContainer = "_57-4";
export var selectButton = "_57-d";
export var spinnerContainer = "_57-b";
export var titleContent = "_57-8";
export var titleWrapper = "_57-6";